import CrudTable from "../../../crud/CrudTable"
import {statebudgetService as service} from "../../../../services"

const initFilter =  {
    name : null,
    code: null,
};


export default function Statedelivery() {

  const createEstructureFilter =  [
     {
       type:"input",
       name: "name",
       col: 4
      },
  ];


  return (
    <CrudTable
          service={service}
          urledit={"/statebudget/edit/"}
          urlnew={"/statebudget/new/"}
          filter={initFilter}
          i18n={"statebudget"}
          fieldstable={["id","name"]}
          estructureForm={createEstructureFilter} />
  );
}
